// extracted by mini-css-extract-plugin
export default {"sign":"TWxylO2O"};